import React from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { firestore } from 'firebase';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import { deletePost } from '../../store/actions/postActions';

import * as ROUTES from '../../constants/routes';

// Not used

const PostDetails = (props) => {
    const { post, id } = props;
    const postDetailsJSX = null;
    const { posts, auth } = props;

    const handleDelete = (e) => {
        e.preventDefault();
        props.deletePost(id);
        props.history.push(ROUTES.HOME);
    }

    if(!auth.uid) return <Redirect to={ROUTES.SIGNIN} />

    if (post) {
        return ( 
            <div className="section post-details">
                <div className="card z-depth-0">
                    <div className="card-content">
                    <span className="card-title">{ post.title }</span>
                    <p>{ post.content }</p>
                    <h1>Post details</h1>
                    </div>
                    <div className="card-action grey lighten-4 grey-text">
                        <div>Posted by { post.authorFirstName } { post.authorLastName }</div>


                    <div>{moment(post.createdAt.toDate()).calendar()}</div>
                    <button onClick={handleDelete}>Delete</button>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className="container center">
                <p>Loading post...</p>
            </div>
        )
    }
};

const mapStateToProps = (state, ownProps) => {
    console.log(state);

    const id = ownProps.match.params.id;
    const posts = state.firestore.data.posts;
    const post = posts ? posts[id] : null;
    return {
        post: post,
        auth: state.firebase.auth,
        id: id
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        deletePost: (id) => dispatch(deletePost(id))
    }
}



export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect([
        { collection: 'posts'}
    ])
)(PostDetails);
